import { CSSProperties, FC } from 'react'
import { colors } from '@lmc/common/constants'
import { ButtonOLD } from '@lmc/ui-kit'

type FooterTypes = {
  residentName: string
  label?: string
  isStart: boolean
  onClose: () => void
  onSuccess: () => void
  goBack: () => void
  onSubmit: () => void
  currentStep: string
  nextStep?: string | null
  onNext?: (step: string) => void
  isSubmitting: boolean
  isGP?: boolean
}

const Footer: FC<FooterTypes> = ({
  residentName,
  label,
  isStart,
  onClose,
  goBack,
  onSubmit,
  currentStep,
  nextStep,
  onNext,
  isSubmitting,
  onSuccess,
  isGP,
}) => (
  <div
    style={{
      ...(styles.container as CSSProperties),
      justifyContent: currentStep === 'success' ? 'flex-end' : 'space-between',
    }}
  >
    {currentStep !== 'success' && (
      <div style={styles.titleContainer as CSSProperties}>
        {label || null}
        <span style={styles.name}>{residentName}</span>
      </div>
    )}
    <div style={styles.buttonsContainer}>
      {currentStep !== 'success' && isGP && currentStep !== 'start-clean' && (
        <ButtonOLD
          type="secondary"
          data-button-type="cancel"
          onClick={isStart ? onClose : goBack}
          style={styles.buttonSecondary}
        >
          {isStart ? 'Cancel' : 'Previous'}
        </ButtonOLD>
      )}
      {currentStep === 'confirm' && (
        <ButtonOLD
          disabled={isSubmitting}
          loading={isSubmitting}
          type="primary"
          data-button-type="submit"
          onClick={onSubmit}
        >
          Sign
        </ButtonOLD>
      )}
      {currentStep !== 'confirm' && currentStep !== 'success' && (
        <ButtonOLD
          type="primary"
          disabled={!nextStep}
          data-button-type="submit"
          onClick={() => onNext?.(nextStep as string)}
        >
          Next
        </ButtonOLD>
      )}
      {currentStep === 'success' && (
        <ButtonOLD type="primary" data-button-type="submit" onClick={onSuccess}>
          Ok
        </ButtonOLD>
      )}
    </div>
  </div>
)

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  titleContainer: {
    fontWeight: 600,
    marginTop: 6,
    fontSize: 16,
    textAlign: 'start',
  },
  name: {
    color: colors.primary,
    paddingLeft: 6,
  },
  buttonsContainer: {
    display: 'flex',
  },
  buttonSecondary: {
    marginRight: 10,
  },
}

export default Footer
